/* ==========================================================================
   LUX — Dark / Light mode toggle
   Mobile (below 750px) always stays dark; the toggle is only interactive at
   tablet width and up. The chosen mode is written to localStorage and read
   back by the blocking inline script in layout/theme.liquid on every load.
   ========================================================================== */

(function () {
  'use strict';

  var STORAGE_KEY = 'lux-theme-mode';
  var root = document.documentElement;
  var mql = window.matchMedia('(min-width: 750px)');

  function readStored() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function writeStored(mode) {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
      /* private mode / storage disabled — toggle still works for this page view */
    }
  }

  function syncToggles(mode) {
    var pressed = mode === 'light' ? 'true' : 'false';
    var toggles = document.querySelectorAll('[data-lux-theme-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].setAttribute('aria-pressed', pressed);
    }
  }

  function applyMode(mode) {
    root.setAttribute('data-lux-theme', mode);
    syncToggles(mode);
  }

  function toggle() {
    if (!mql.matches) return;
    var next = root.getAttribute('data-lux-theme') === 'light' ? 'dark' : 'light';
    applyMode(next);
    writeStored(next);
  }

  function syncToViewport() {
    if (!mql.matches) {
      applyMode('dark');
      return;
    }
    var stored = readStored();
    applyMode(stored === 'light' ? 'light' : 'dark');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lux-theme-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle();
  });

  if (mql.addEventListener) {
    mql.addEventListener('change', syncToViewport);
  } else if (mql.addListener) {
    mql.addListener(syncToViewport);
  }

  // Safety net: re-checks the viewport once the DOM is available, in case the
  // blocking inline script in <head> ever raced a very early viewport change
  // (e.g. some webviews report layout dimensions a tick late). Cheap and
  // idempotent — on a normal load this just confirms what <head> already set.
  syncToViewport();

  document.addEventListener('DOMContentLoaded', function () {
    syncToggles(root.getAttribute('data-lux-theme') || 'dark');
  });
})();
